import React, {
} from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import DescriptionIcon from '@material-ui/icons/Description';
import Paper from '~/components/Paper';
import InputControl from '~/components/Input/InputControl';
import Form from '~/containers/Form';
import GridContainer from '~/components/GridContainer';
import GridItem from '~/components/GridItem';
import useStyles from './styles';
import FileRecord from '~/records/FileRecord';
import InputCheckBox from '~/components/Input/InputCheckBox';
// import InputNumber from '~/components/Input/InputNumber';
import InputSelect from '~/components/Input/InputSelect';
// import packageTypesEnum from '~/enums/packageTypesEnum';
import keysVideosEnum from '~/enums/keysVideosEnum';
import LinearProgress from '~/components/LinearProgress';
import InputFile from '~/components/Input/InputFile';

const attrName = (attr) => FileRecord.hummanAttributeName(attr);

function FileItem({ setRecord, record, handleChange, onSubmit, loading }) {
  const classesRoot = useStyles();
  const { t } = useTranslation();
  const isPersisted = record.isPersisted();

  return (
    <>
      <Form onSubmit={onSubmit} >
        <Paper
          Icon={DescriptionIcon}
          iconColor={isPersisted ? 'purple' : 'blue'}
          title={t('files.defSingular')}
          loading={loading}
          subtitle={t('wait_load')}
        >
          <div className={clsx(classesRoot.root)}>
            <GridContainer>
              <GridItem xs={6} md={6}>
                {loading && <LinearProgress style={{ height: 4 }} color="secondary" />}
                <InputFile
                  disabled={loading}
                  multiple={false}
                  accept={'video/mp4,video/x-m4v,video/*'}
                  label={t('dropzone_file_placeholder')}
                  onChange={(files)=> {
                    setRecord(record.updateAttributes({ files }));
                  }}
                />
              </GridItem>
                <GridItem xs={12} md={3}>
                  <InputControl
                    value={record.get('key')}
                    name='key'
                    disabled={loading}
                    label={attrName('key')}
                    inputComponent={InputSelect}
                    InputProps={{
                      options: keysVideosEnum().array,
                      placeholder: t('addon.type.placeholder'),
                      outValueType: 'string'
                    }}
                    onChange={handleChange}
                  />
                </GridItem>
                {/* <GridItem xs={12} md={3}>
                  <InputControl
                    value={record.get('pack_type')}
                    name='pack_type'
                    disabled={loading}
                    label={attrName('pack_type')}
                    inputComponent={InputSelect}
                    InputProps={{
                      options: packageTypesEnum().array,
                      placeholder: t('addon.type.placeholder'),
                      outValueType: 'string'
                    }}
                    onChange={handleChange}
                  />
                </GridItem> */}
                {/* <GridItem xs={1} sm={1} md={1}>
                  <InputControl
                    value={record.get('order')}
                    name={'order'}
                    label={attrName('order')}
                    inputComponent={InputNumber}
                    onChange={handleChange}
                    InputProps={{
                      precision: 0,
                      showMask: false,
                    }}
                  />
                </GridItem> */}
                <GridItem xs={1} sm={1} md={1}>
                  <InputControl
                    disabled={loading}
                    value={record.get('is_active')}
                    name="is_active"
                    label={attrName('is_active')}
                    inputComponent={InputCheckBox}
                    onChange={handleChange}
                    InputProps={{
                    }}
                  />
                </GridItem>
                {/* {loading && <GridItem xs={12}>
                <p style={{ fontSize: 30, textAlign: 'center' }}>{t('wait_load')}</p>
                </GridItem>} */}
            </GridContainer>
          </div>
        </Paper>
      </Form>
    </>
  );
}

FileItem.propTypes = {
  loading:      PropTypes.bool,
  record:       PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  onSubmit:     PropTypes.func.isRequired,
  setRecord:    PropTypes.func.isRequired,
};

FileItem.defaultProps = {
  loading: false,
};

export default React.memo(withRouter(FileItem));
